"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Detail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var message_1 = require("../../model/message");
var service_1 = require("../../../library/base/service");
var Detail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的消息详情接口';
        _this.code = '101005';
        _this.desc = '我的消息详情接口';
        _this.requestParams = new message_1.DetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Detail;
}(service_1.BaseService));
exports.Detail = Detail;
//# sourceMappingURL=detail.js.map